// rxjs-extension/reactives/set.ts
import { BehaviorSubject } from "rxjs";
var SetBehaviorSubject = class extends BehaviorSubject {
  constructor(defaultSet = /* @__PURE__ */ new Set()) {
    super(defaultSet);
  }
  add(item) {
    const returnValue = this.getValue().add(item);
    this.next(this.getValue());
    return returnValue;
  }
  clear() {
    const returnValue = this.getValue().clear();
    this.next(this.getValue());
    return returnValue;
  }
  delete(item) {
    const returnValue = this.getValue().delete(item);
    this.next(this.getValue());
    return returnValue;
  }
  // cant implement, would overwrite behaviorsubject
  // forEach() {}
  has(item) {
    return this.getValue().has(item);
  }
  values() {
    return this.getValue().values();
  }
  get size() {
    return this.getValue().size;
  }
  toArray() {
    return [...this.values()];
  }
};
export {
  SetBehaviorSubject
};
